export const NODE_TYPE_FOOTNOTE = 'footnote';
